
import moment from 'moment';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import productPromotionQuery from '~/apollo/queries/product/productPromotion.gql';
import lgmMixin from '~/mixins/lgmMixin';

export default {
  mixins: [eventTrackingMixins, lgmMixin],
  props: [
    'promotionId',
    'scenarioId',
    'company',
    'productCategory',
    'productName',
    'productId',
    'ctaButtonLink',
    'ctaButtonText'
  ],

  data() {
    return {
      promotion: null,
      loading: 0,
      isShowTermsAndConditions: false
    };
  },
  // page component definitions
  apollo: {
    promotion: {
      query: productPromotionQuery,
      prefetch: true,
      variables() {
        return {
          id: parseInt(this.promotionId),
          currentlocale: this.$normalizeLocale(this.$i18n.locale)
        };
      },
      update(data) {
        return this.$normalizeStrapi(data.productPromotions.data[0]);
      }
    }
  },
  methods: {
    handleEventTracking_modalPromotionContent(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target);

      const href = dataFromClickedElement?.href;
      const linkText = dataFromClickedElement?.link_text;

      const eventTrackingParams = this.initEventTrackingParams();

      if (dataFromClickedElement.tracking_target.target_code === 'product-promo-modal-cta') {
        // #14
        if (this.isTransitionLink(href)) {
          event.preventDefault();
          // #14
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = this.company?.name || productData.product.insurer_name;
          const productScenarioCode = this.productId || productData.product.scenario_code;
          const productName = this.productName || productData.product.product_name;
          const productCategory = this.productCategory || productData.product.product_category;
          eventTrackingParams.a = 'click_redirection';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `promo_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-promo-modal-cta', eventTrackingParams, 'transitionLink');

        } else if (this.isEComLink(href)) {
          event.preventDefault();
          // #150
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = this.company?.name || productData.product.insurer_name;
          const productScenarioCode = this.productId || productData.product.scenario_code;
          const productName = this.productName || productData.product.product_name;
          const productCategory = this.productCategory || productData.product.product_category;
          eventTrackingParams.a = 'to_ecom_site';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `promo_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;

          this.openWindowWithLGMUrl(event, '.product-promo-modal-cta', eventTrackingParams, 'eCommerceSite');

        } else {
          // #14
          const productData = this.extractDataFromCurrentProductDetailPage();
          const insuranceCompany = productData.product.insurer_name;
          const productScenarioCode = productData.product.scenario_code;
          const productName = productData.product.product_name;
          const productCategory = productData.product.product_category;
          eventTrackingParams.a = 'click_redirection';
          eventTrackingParams.l = productScenarioCode;
          eventTrackingParams.c = `promo_details_cta`;
          eventTrackingParams.cd.insurer_name = insuranceCompany;
          eventTrackingParams.cd.product_name = productName;
          eventTrackingParams.cd.product_category = productCategory;
        }
      }

      this.sendEventTracking(eventTrackingParams)
    },

    showTermsAndConditions() {
      this.isShowTermsAndConditions = !this.isShowTermsAndConditions;
    },

    convertEmbedVideo(data) {
      if ( data.includes('raw-html-embed') && data.includes('iframe')) {
        const modifiedData = data.replace(/<iframe/g, '<iframe style="width:100%;height:auto;aspect-ratio:16/9;"');
        return modifiedData;
      } else {
        return data;
      }
    }
  },
};
